import React, { FunctionComponent, memo, ReactNode } from 'react'
import styles from './TagList.module.sass'
import { Tag } from '../../../../responses/tags'
import TagElement from '../TagElement/TagElement'
import { AnimatePresence } from 'framer-motion'
import clsx from 'clsx'

interface Props {
    className?: string,
    tags: Tag[],
    constantTags?: Tag[],
    delete?: boolean,
    inverted?: boolean,
    reverse?: boolean,
    disabled?: boolean,
    onClick?: (tag: Tag) => void,
    children?: ReactNode,
}

const TagList: FunctionComponent<Props> = props =>
    <div className={clsx(props.className, styles.list)}>
        <div className={clsx(styles.content, {[styles.reverse]: props.reverse})}>
            <AnimatePresence>
                {
                    props.children
                }
                {
                    props.constantTags?.map(tag => <TagElement
                        key={'c_' + tag.id}
                        className={styles.tag}
                        inverted={props.inverted}
                        delete={props.delete}
                        tag={tag}
                    />)
                }
                {
                    props.tags.map(tag => <TagElement
                        key={tag.id}
                        className={styles.tag}
                        tag={tag}
                        inverted={props.inverted}
                        delete={props.delete}
                        disabled={!props.onClick || props.disabled}
                        onClick={() => props.onClick?.(tag)}
                    />)
                }
            </AnimatePresence>
        </div>
    </div>

export default memo(TagList)